export const WUJI_DEPS_KEY = '_wuji_deps';
